import {Component, OnInit, ElementRef, Renderer2} from '@angular/core';
import {NgbDate, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {DomSanitizer} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {environment} from 'src/environments/environment';
import {ProgressService} from 'src/app/services/progress.service';
import {DialogService} from 'src/app/services/dialog.service';
import {TrustiiService} from 'src/app/services/trustii.service';
import {SessionService} from 'src/app/services/session.service';
import {AutoMLGenerateService} from 'src/app/services/async.service';
import {_} from 'underscore';
import {DataService} from 'src/app/services/data.service';
import {FileService} from 'src/app/services/file.service';
import MyEditor from 'ckeditor5-custom-build/build/ckeditor';
import MyEditor2 from 'ckeditor5-custom-build/build/ckeditor';
import {tap, filter, distinctUntilChanged} from 'rxjs/operators';
import {VideoDialogComponent} from 'src/app/shared/video-dialog/video-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {saveAs} from 'file-saver';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';

@Component({
  selector: 'app-enterprise-dataset-configuration',
  templateUrl: './dataset-configuration.component.html',
  styleUrls: ['./dataset-configuration.component.scss']
})
export class EnterpriseDatasetConfigurationComponent implements OnInit {
  description;
  prizeDescription;
  progress = 0;
  inProgress = false;
  isAllSelected = true;
  progressMessage = 'Please wait, we are preparing the Dataset and generating Automated ML model...';
  goal = null;
  devMode = false;
  elements: any = [];
  originalState: any = [];
  nameClicked = false;
  totalRecords = 0;
  burstSize = 2000;
  percentageIncrement = null;
  p = 1;
  loading = null;
  fields = [];
  buildModelButtonState = false;
  mlModelType = null;
  threshold = 0.5;
  prize = 0;
  thresholdAlredySet = false;
  processingTime = 2;
  displayName = null;
  scope = 'public';
  category = 'default';
  datasetCateogoryOptions = [];
  datasetFieldOptions = [];
  datasetMultiLabelsClassificationScoreOptions = [];
  datasetClassificationScoreOptions = [];
  datasetRegressionScoreOptions = [];
  universities = [];
  selectedUniversities = [];
  uploadedAt = null;
  withNotebook = true;
  canDownloadNotebook = 'no';

  datasetIcon = null;
  updatedDatasetIcon = null;
  termsFile = null;
  imageError: string;
  currentDate = this.parseDateToStringWithFormat(new Date().toISOString());
  emailList = [];
  emailRegexp = new RegExp(/^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i);
  enteredEmail = null;
  emailValidationError = false;
  overrideOrAppend = false;
  fileImportedSuccessfully = false;
  availableHour: Array<string> = [
    '00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11',
    '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23',
  ];
  availableMinute: Array<string> = [
    '00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11',
    '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23',
    '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35',
    '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47',
    '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59',
  ];
  endDate: NgbDateStruct = this.getDateObject(30); // 30 days to default
  endHour = '23';
  endMinute = '59';
  startDate: NgbDateStruct = this.getDateObject(10); // 10 days to default
  startHour = '00';
  startMinute = '00';
  endTime = '23:59';
  time = {hour: 24, minute: 0};
  minStartDate = this.getDateObject(0); // minimum 1 day
  minDate = this.getDateObject(1); // minimum 1 day
  maxDate = this.getDateObject(182); // max 6 months
  currentStepNumber = 1;
  maxProcessingTime = 10;
  haveTerms = 'no';
  useCustomBaseline = false;
  customBaseline = null;
  targetScore = null;
  video = null;
  status = null;
  generateAutoMl = false;
  nbModels = 0;
  public Editor = MyEditor;
  public Editor2 = MyEditor2;
  datasetFiles = [];
  haveFiles = false;
  uploadInProgress = false;
  fileToUpload = [];
  steps = [
    {
      number: 1,
      description: 'Basic'
    },
    {
      number: 2,
      description: 'Files'
    },
    {
      number: 3,
      description: 'Prediction'
    },
    {
      number: 4,
      description: 'Param'
    },
    {
      number: 5,
      description: 'Access'
    }
  ];
  nbTarget = 0;

  constructor(
    private dialogService: DialogService,
    private host: ElementRef, private renderer: Renderer2, private router: Router,
    private progressService: ProgressService, private sessionService: SessionService,
    private trustiiService: TrustiiService, public dataservice: DataService, public fileService: FileService,
    public domSanitizer: DomSanitizer, private autoMlService: AutoMLGenerateService, private matDialog: MatDialog
  ) {
  }

  ngOnInit() {
    this.devMode = !environment.production;
    this.getDataSet();
    this.datasetClassificationScoreOptions = Object.keys(this.dataservice.datasetClassificationScore);
    this.datasetMultiLabelsClassificationScoreOptions = Object.keys(this.dataservice.datasetMultiLabelsClassificationScore);
    this.datasetRegressionScoreOptions = Object.keys(this.dataservice.datasetRegressionScore);
    this.datasetFieldOptions = Object.keys(this.dataservice.datasetFieldType);
    this.datasetCateogoryOptions = (this.sessionService.getVendor().planId === 1 || this.sessionService.getVendor().planId === 2) ?
      Object.keys(this.dataservice.datasetCategoryWithoutChallenge) : Object.keys(this.dataservice.datasetCategory);
    this.enteredEmail = '';
    this.maxProcessingTime = this.sessionService.isFreePlan() ? 10 : 60;
    this.getMlModels();
    if (this.canAccessChallengeFunctionnality()) {
      this.getDatasetAccessList();
      this.getUniversities();
    }
  }

  canGenerateAutoModel() {
    return this.sessionService.canGenerateAutoModel(this.processingTime);
  }

  canAccessChallengeFunctionnality() {
    return this.sessionService.canAccessChallengeFunctionnality();
  }

  getDatasetAccessList() {
    this.trustiiService.getDatasetAccessList(this.dataservice.data.id).subscribe(
      (res) => {
        this.emailList = res.data.vendors.map(item => {
          return item.name;
        });
        this.selectedUniversities = res.data.universities.map(item => {
          return item.id;
        });
      }, (err) => {
        // Nothing
      }
    );
  }

  getUniversities() {
    this.trustiiService.getUniversities().subscribe(
      (res) => {
        this.universities = res.data;
      }, (err) => {
        // Nothing
      }
    );
  }

  getDataSet() {
    const loadingMsg = 'Loading your dataset. Please wait....';
    this.progressService.progressBar.next({loading: true, message: loadingMsg, inProgress: true});
    this.trustiiService.getDatasetFiles(this.dataservice.data.id).subscribe((data) => {
      this.datasetFiles = data.data;
      this.haveFiles = this.datasetFiles.length > 0;
    });
    this.trustiiService.getDataset(this.dataservice.data.id).subscribe(
      (res) => {
        if ('in-progress' === res.data.status) {
          setTimeout(() => {
            this.getDataSet();
          }, 3 * 1000); // poll every 3 seconds
        } else {
          if (res.data.status === 'removed') {
            this.router.navigateByUrl('enterprise/datasets');
          }
          this.status = res.data.status;
          this.dataservice.setData(res.data);
          this.uploadedAt = this.dataservice.data.uploadedAt;
          this.displayName = this.dataservice.data.displayName;
          this.category = (this.dataservice.data.category === 'default') ? 'education' : this.dataservice.data.category;
          this.scope = this.dataservice.data.scope;
          this.endDate = this.dataservice.data.endDate;
          this.endDate = this.endDate !== null ? this.parseDateToNGDateStructFormat(this.endDate, 'end') :
            this.getDateObject(30); // 30 days for default
          this.startDate = this.dataservice.data.startDate;
          this.startDate = this.startDate !== null ? this.parseDateToNGDateStructFormat(this.startDate, 'start') :
            this.getDateObject(10); // 10 days for default
          this.datasetIcon = this.dataservice.data.image !== null ? this.dataservice.data.image :
            this.dataservice.defaultDatasetIcon;
          this.datasetIcon = this.domSanitizer.bypassSecurityTrustUrl('/assets/img/logo-cover.png');
          this.description = this.dataservice.data.description;
          this.prize = res.data.prize;
          this.prizeDescription = res.data.prizeDescription;
          this.goal = this.dataservice.data.goal;
          if (res.data.threshold !== null) {
            this.threshold = res.data.threshold;
            this.thresholdAlredySet = true;
          }
          this.processingTime = res.data.processingTime === null ? this.processingTime : res.data.processingTime;
          this.customBaseline = res.data.customBaseline;
          this.useCustomBaseline = res.data.useCustomBaseline === 'yes';
          this.withNotebook = res.data.withNotebook === 'yes';
          this.canDownloadNotebook = res.data.canDownloadNotebook;
          this.mlModelType = this.dataservice.data.mlProblem;
          this.elements = this.dataservice.data.fields.sort((a, b) => a.fieldOrder - b.fieldOrder);
          this.totalRecords = this.elements.length;
          this.elements.forEach((item) => {
            if (item.isTarget === 1) {
              this.nbTarget++;
            }
          });
          this.updateAllSelected();
          this.buildModelButtonState = this.isButtonDisabled();
          this.haveTerms = res.data.haveTerms;
          if (res.data.customScore !== null) {
            this.datasetClassificationScoreOptions.push(res.data.customScore);
            this.datasetRegressionScoreOptions.push(res.data.customScore);
            this.datasetMultiLabelsClassificationScoreOptions.push(res.data.customScore);
          }
          this.targetScore = res.data.targetScore;
          this.video = res.data.video;
          this.inProgress = false;
          this.percentageIncrement = 100 / (this.totalRecords / this.burstSize);
          this.progressService.progressBar.next({loading: false, message: loadingMsg, inProgress: false});
        }
      },
      (err) => {
        this.inProgress = false;
        this.progressService.progressBar.next({loading: false, message: loadingMsg, inProgress: false});
        this.dialogService.openConfirmDialog('Failed to Load Dataset. Retry?').pipe(
          distinctUntilChanged(),
          filter((result) => result && result.data === 'confirmation'),
          tap(() => this.getDataSet())
        ).subscribe();
      }
    );
  }

  getMlModels(): void {
    this.trustiiService.getMlModels(this.dataservice.data.name, this.dataservice.data.id, 1, 10).subscribe(
      (res) => {
        this.nbModels = res.data.length;
      },
      (err) => {
        this.nbModels = 0;
      }
    );
  }

  toggleNameClicked() {
    this.nameClicked = !this.nameClicked;
  }

  updateAllSelected() {
    this.isAllSelected = this.elements.every(item => {
      return item.isTarget === 1;
    });
  }

  isTargetSelected(): boolean {
    return this.elements.some(element => element.isTarget === 1);
  }

  isButtonDisabled() {
    if (!this.goal || this.goal.length < 1) {
      return true;
    }
    if (!this.description || this.description.length < 1) {
      return true;
    }
    if (!this.endDate) {
      return true;
    }
    if (!this.startDate) {
      return true;
    }
    if (!this.mlModelType) {
      return true;
    }
    // last check to make sure isTarget is selected
    return !this.isTargetSelected();
  }

  updateDescrition({ editor }: ChangeEvent) {
    this.description = editor.getData();
  }

  updatePrizeDescrition({ editor }: ChangeEvent) {
    this.prizeDescription = editor.getData();
  }

  prepareDatasetUpdate(): any {
    return {
      displayName: this.displayName,
      description: this.description,
      prize: this.prize,
      prizeDescription: this.prizeDescription,
      goal: this.goal,
      mlProblem: this.mlModelType,
      category: this.category,
      scope: this.scope,
      targetScore: this.targetScore,
      customBaseline: this.customBaseline,
      useCustomBaseline: this.useCustomBaseline ? 'yes' : 'no',
      withNotebook: this.withNotebook ? 'yes' : 'no',
      canDownloadNotebook: this.canDownloadNotebook,
      video: this.video,
      endDate: this.getISOStringFromDate(this.endDate, this.endHour, this.endMinute),
      startDate: this.getISOStringFromDate(this.startDate, this.startHour, this.startMinute),
      threshold: this.mlModelType === 'regression' ? null : this.threshold,
      image: this.updatedDatasetIcon !== null ? this.updatedDatasetIcon.split('base64,')[1] : null,
      processingTime: this.processingTime,
      fields: this.elements.length > this.burstSize ?
        this.elements.slice(0, this.burstSize) :
        this.elements.slice(0, this.elements.length)
    };
  }

  updateDatasetAccess() {
    if (!this.canAccessChallengeFunctionnality() || this.scope === 'public') {
      return;
    }

    const selectedUniversities = this.universities.filter((university) => this.selectedUniversities.includes(university.id));
    const emailListPayload = {
      emails: this.emailList.join(),
      universities: selectedUniversities,
      type: this.overrideOrAppend ? 'override' : 'append'
    };

    if ((emailListPayload.emails && emailListPayload.emails.trim() !== '') || this.selectedUniversities.length > 0) {
      this.trustiiService.updateDatasetAccessList(emailListPayload, this.dataservice.data.id).subscribe(
        (res) => {
          // Do nothing
        }, (err) => {
          this.dialogService.openAlertDialog(
            '350px',
            'Failed to upload dataset access list. please try again later',
            'ERROR',
            'Ok',
            'modal-warning'
          );
        }
      );
    }
  }

  updateDatasetTerms() {
    if (!this.canAccessChallengeFunctionnality() || !this.termsFile) {
      return;
    }

    const formData = new FormData();
    formData.append('datasetFile', this.termsFile, 'terms.pdf');

    this.trustiiService.uploadTerms(formData, this.dataservice.data.id).subscribe(
      (res) => {
        // Do nothing
      }, (err) => {
        this.dialogService.openAlertDialog(
          '350px',
          'Failed to upload dataset terms. please try again later',
          'ERROR',
          'Ok',
          'modal-warning'
        );
      }
    );
  }

  updateDataset(buildModel: boolean = true) {
    buildModel = this.generateAutoMl && !this.useCustomBaseline;
    this.updateDatasetAccess();
    this.updateDatasetTerms();
    const updatePayload = this.prepareDatasetUpdate();

    if (buildModel && !this.sessionService.canGenerateAutoModel(this.processingTime)) {
      this.dialogService.openAlertDialog(
        '350px',
        'You have reached the processing time limit, you can\'t generate an Auto ML.',
        'ERROR',
        'Ok',
        'modal-warning'
      );
      return;
    }

    if (this.dataservice.data.category !== this.category &&
      (this.category === 'challenge-no-prize' || this.category === 'challenge-prize') &&
      !this.sessionService.canCreateChallenge()) {
      this.dialogService.openAlertDialog(
        '350px',
        'You have reached the challenge limit, you can\'t set another dataset as challenge.',
        'ERROR',
        'Ok',
        'modal-warning'
      );
      return;
    }

    if (buildModel && this.sessionService.willReachAutoModelLimit(this.processingTime)) {
      const message = 'You will reach your processing time limit for this month, ' +
        'if you continue you will pay extra fees. Do you confirm ?';
      this.dialogService.openConfirmDialog(message).pipe(
        distinctUntilChanged(),
        filter((result) => result && result.data === 'confirmation'),
        tap(() => this.runUpdateDataset(updatePayload, buildModel))
      ).subscribe();
      return;
    }

    this.runUpdateDataset(updatePayload, buildModel);
  }

  runUpdateDataset(updatePayload: any, buildModel: boolean = true) {
    this.inProgress = true;
    this.trustiiService.updateDataset(updatePayload, this.dataservice.data.id).subscribe(
      (res) => {
        this.sessionService.refreshUser();
        this.handleDatasetStatus(res.data, buildModel);
      },
      (err) => {
        this.inProgress = false;
        let alertMessage = (buildModel) ? 'Failed to build model' : 'Failed to update the dataset';
        if (err.error && err.error.error && err.error.error.message) {
          alertMessage = alertMessage + '<br/><small>' + err.error.error.message + '</small>';
        }
        this.dialogService.openAlertDialog(
          '350px',
          alertMessage,
          'ERROR',
          'Ok',
          'modal-warning'
        );
      }
    );
  }

  handleDatasetStatus(dataset: any, buildModel: boolean) {
    if (dataset.status && (dataset.status === 'hidden' || dataset.status === 'configured')) {
      if (buildModel) {
        this.autoMlService.generate(this.dataservice.data.id, this.dataservice.data.name);
      }
      this.router.navigateByUrl('enterprise/datasets');
      return;
    }

    this.trustiiService.getDataset(this.dataservice.data.id).subscribe(
      (res) => {
        if ('split-in-progress' === res.data.status) {
          setTimeout(() => {
            this.handleDatasetStatus(dataset, buildModel);
          }, 10 * 1000); // poll every 10 seconds
          return;
        } else if ('done' === res.data.status) {
          this.inProgress = false;
          const alertMessage = (buildModel) ? 'Failed to build model' : 'Failed to update the dataset';
          this.dialogService.openAlertDialog(
            '350px',
            alertMessage,
            'ERROR',
            'Ok',
            'modal-warning'
          );
          return;
        } else {
          if (buildModel) {
            this.autoMlService.generate(this.dataservice.data.id, this.dataservice.data.name);
          }
          this.router.navigateByUrl('enterprise/datasets');
          return;
        }
      },
      (err) => {
        this.inProgress = false;
        const alertMessage = 'Failed to build model.';
        this.dialogService.openAlertDialog(
          '350px',
          alertMessage,
          'ERROR',
          'Ok',
          'modal-warning'
        );
      }
    );
  }

  handleTarget(e) {
    if (e.target.checked) {
      this.updateDataSet(e.target.closest('tr').getAttribute('data-id'), 1, 0);
    } else {
      this.updateDataSet(e.target.closest('tr').getAttribute('data-id'), 0, undefined);
    }
    this.buildModelButtonState = this.isButtonDisabled();
  }

  handleType() {
    this.buildModelButtonState = this.isButtonDisabled();
  }

  onGoalKey(e) {
    this.goal = e.target.value;
    this.buildModelButtonState = this.isButtonDisabled();
  }

  onModelTypeRadio(e) {
    this.mlModelType = e.target.value;
    this.buildModelButtonState = this.isButtonDisabled();
  }

  onEndDateChange(date: NgbDate) {
    if (!date.year) {
      this.endDate = this.getDateObject(7); // reset the users invalid input to minimum date
    } else {
      this.endDate = date;
    }
    if (date.after(this.maxDate)) {
      this.endDate = this.maxDate;
    } else if (date.before(this.minDate)) {
      this.endDate = this.minDate;
    }
  }

  onStartDateChange(date: NgbDate) {
    if (!date.year) {
      this.startDate = this.getDateObject(7); // reset the users invalid input to minimum date
    } else {
      this.startDate = date;
    }
    if (date.after(this.maxDate)) {
      this.startDate = this.maxDate;
    } else if (date.before(this.minStartDate)) {
      this.startDate = this.minStartDate;
    }
  }

  updateDataSet(id, isTarget, toSanitize) {
    this.elements.filter((item) => {
      if (item.id === parseInt(id, 10)) {
        if (isTarget !== undefined) {
          item.isTarget = isTarget;
          if (isTarget === 1) {
            item.type = 'default';
            this.nbTarget++;
          } else {
            this.nbTarget--;
          }
        }
        if (toSanitize !== undefined) {
          item.toSanitize = toSanitize;
        }
      } else {
        // item.isTarget = 0;
        // this.nbTarget--;
      }
    });
    if (this.nbTarget > 1) {
      this.mlModelType = 'multi-labels-classification';
      this.targetScore = 'accuracy_score';
    } else {
      this.mlModelType = 'classification';
      this.targetScore = 'accuracy_score';
    }
  }

  onThresholdKey(e) {
    this.threshold = e.target.value;
    if (e.target.value > 1) {
      this.threshold = 1;
    }
    if (e.target.value < 0) {
      this.threshold = 0;
    }
  }

  onProcessingTimeKey(e) {
    this.processingTime = e.target.value;
    this.processingTime = e.target.value;
    if (e.target.value > this.maxProcessingTime) {
      this.processingTime = this.maxProcessingTime;
    }
    if (e.target.value < 0) {
      this.processingTime = 0;
    }
  }

  parseDateToNGDateStructFormat(dateString, type = 'end') {
    const date = new Date(dateString);
    if (type === 'start') {
      this.startHour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours().toString();
      this.startMinute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes().toString();
    } else {
      this.endHour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours().toString();
      this.endMinute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes().toString();
    }
    return {day: date.getDate(), month: date.getMonth() + 1, year: date.getFullYear()};
  }

  parseDateToStringWithFormat(dateString): NgbDateStruct {
    const date = new Date(dateString);
    const dd = date.getDate();
    const mm = (date.getMonth() + 1);

    return {
      year: date.getFullYear(),
      month: mm,
      day: dd
    };
  }

  onImageUpload(options) {
    const fileConent = options.that.fileService.file;
    options.that.fileService.file = null;
    const allowedTypes = ['image/png', 'image/jpeg'];
    if (!_.includes(allowedTypes, fileConent.type)) {
      options.that.dialogService.openAlertDialog(
        '350px',
        'only JPG or PNG are allowed image types.',
        'ERROR',
        'Ok',
        'modal-warning'
      );
      return false;
    }

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const image = new Image();
      image.src = e.target.result;
      image.onload = rs => {
        options.that.updatedDatasetIcon = e.target.result;
      };
    };

    reader.readAsDataURL(fileConent);
  }

  onTermsUpload(options) {
    const fileContent = options.that.fileService.file;

    options.that.fileService.file = null;
    const allowedTypes = ['application/pdf'];
    if (!_.includes(allowedTypes, fileContent.type)) {
      options.that.dialogService.openAlertDialog(
        '350px',
        'only PDF is allowed.',
        'ERROR',
        'Ok',
        'modal-warning'
      );
      return false;
    }

    options.that.termsFile = fileContent;
  }

  updateEmailList(e, emailId) {
    this.emailList = this.emailList.filter(item => item !== emailId);
  }

  addToEmailList(e) {
    this.enteredEmail = this.enteredEmail.replaceAll(' ', ''); // remove all spaces
    const inputEmailList = this.enteredEmail.split(',');
    const invalidEmailList = [];
    let validEmailFound = false;
    inputEmailList.forEach(email => {
      if (this.emailRegexp.test(email)) {
        this.emailList.push(email);
        validEmailFound = true;
      } else {
        invalidEmailList.push(email);
      }
    });

    if (invalidEmailList.length > 0) {
      this.enteredEmail = invalidEmailList.join();
      this.emailValidationError = true;
    }

    if (validEmailFound) {
      this.enteredEmail = invalidEmailList.join();
    }
  }

  onEmailKeyUp() {
    this.emailValidationError = false;
    this.enteredEmail = this.enteredEmail.replaceAll(' ', ''); // remove all spaces
  }

  importCSVfile(options) {
    const fileConent = options.that.fileService.file;
    options.that.fileService.file = null;
    const allowedTypes = ['text/csv'];
    options.that.fileImportedSuccessfully = false;
    if (!_.includes(allowedTypes, fileConent.type)) {
      options.that.dialogService.openAlertDialog(
        '350px',
        'only CSV format are allowed',
        'ERROR',
        'Ok',
        'modal-warning'
      );
      return false;
    }
    // const fileReader = new FileReader();
    const fileReader: FileReader = new FileReader();
    fileReader.onload = (fileLoadedEvent) => {
      let invalidEmailContent = false;
      const invalidEmailContentList = [];
      const textFromFileLoaded = fileReader.result as string;
      textFromFileLoaded.split(',').forEach(email => {
        email = email.trim();
        if (!options.that.emailRegexp.test(email) && email !== '') {
          invalidEmailContentList.push(email);
          invalidEmailContent = true;
        }
      });

      options.that.emailList = textFromFileLoaded.split(',').filter(email => {
        email = email.trim();
        if (options.that.emailRegexp.test(email)) {
          return email;
        }
      });

      if (invalidEmailContent) {
        options.that.dialogService.openAlertDialog(
          '350px',
          'Email Ids "' + invalidEmailContentList.join() + '" are in invalid format',
          'ERROR',
          'Ok',
          'modal-warning'
        );
      }
      options.that.fileImportedSuccessfully = true;
    };
    fileReader.readAsText(fileConent, 'UTF-8');
  }

  getDateObject(daysCount) {
    const date = new Date();
    date.setDate(date.getDate() + daysCount);
    return {day: date.getUTCDate(), month: date.getUTCMonth() + 1, year: date.getUTCFullYear()};
  }

  getISOStringFromDate(date: NgbDateStruct, hour, minute) {
    const dateObject = new Date(date.year.toString() + '/' + date.month.toString() + '/' + date.day.toString());
    dateObject.setHours(hour, minute);
    return dateObject.toISOString();
  }

  openVideo() {
    this.matDialog.open(VideoDialogComponent, {
      height: '400px',
      width: '600px',
      data: {
        video: this.video,
      },
    }).afterClosed().subscribe();
  }

  downloadTrustiiRules() {
    this.trustiiService.getDatasetTerms(this.dataservice.data.id).subscribe(
      (res) => {
        saveAs(res, 'challenge-rules.csv');
      },
      (err) => {
        this.dialogService.openAlertDialog(
          '350px',
          'failed to download rules. Please retry again after sometime',
          'ERROR',
          'Ok',
          'modal-warning'
        );
      }
    );
  }

  public dropped(event) {
    if (event.target.files.length === 0) {
      return;
    }
    const file = event.target.files[0];
    file.customId = file.name + Date.now();
    file.uploaded = 'no';
    this.fileToUpload.push(file);
    const formData = new FormData();
    formData.append('datasetFile', file, file.name);
    if (this.sessionService.willReachDatasetLimit(file.size)) {
      this.dialogService.openAlertDialog(
        '350px',
        'You have reached your monthly limit, you can\'t upload more files.',
        'ERROR',
        'Ok',
        'modal-warning'
      );
      return;
    }

    this.uploadDatasetFiles(formData, file.customId);
  }

  private uploadDatasetFiles(formData: FormData, customId: string) {
    this.uploadInProgress = true;
    this.trustiiService.uploadDatasetFile(this.dataservice.data.id, formData).subscribe(
      (res) => {
        if (res.status === 'progress') {
          // console.log('IN PROGRESS');
        } else if (res.status === 'error') {
          this.uploadInProgress = false;
          this.dialogService.openAlertDialog(
            '350px',
            'Error uploading file: ' + name,
            'ERROR',
            'Ok',
            'modal-warning'
          );
        } else if (res.data) {
          this.uploadInProgress = false;
          this.fileToUpload.map((item) => {
            if (item.customId === customId) {
              item.id = res.data.id;
              item.uploadedAt = res.data.uploadedAt;
              item.uploaded = 'yes';
              this.haveFiles = true;
            }
          });
          this.sessionService.refreshUser();
        }
      },
      (err) => {
        this.uploadInProgress = false;
        this.dialogService.openAlertDialog(
          '350px',
          'Error uploading file: ' + name,
          'ERROR',
          'Ok',
          'modal-warning'
        );
      }
    );
  }

  removeDatasetFile(key: number, fileId: number, isUpload: boolean) {
    this.dialogService.openConfirmDialog('Are you sure you want to remove the file?').pipe(
      distinctUntilChanged(),
      filter((result) => result && result.data === 'confirmation'),
      tap(() => this.deleteDatasetFile(key, fileId, isUpload))
    ).subscribe();
  }

  private deleteDatasetFile(key: number, fileId: number, isUpload: boolean) {
    this.trustiiService.removeDatasetFile(this.dataservice.data.id, fileId).pipe(
      tap(data => {
        if (isUpload) {
          this.fileToUpload.splice(key, 1);
        } else {
          this.datasetFiles.splice(key, 1);
        }
        if (this.fileToUpload.length === 0 && this.datasetFiles.length === 0) {
          this.haveFiles = false;
        }
      })
    ).subscribe();
  }
}
